import type { VisibilityFilter } from "@albertine/types";
import { TenantSchema, ThemeContentTenantSchema } from "@albertine/types/openapi/lmt";
import {
    dynamicThemeNameMaxLength,
    ThemeLocation,
    ThemePreference,
} from "@albertine/types/theme";
import { z } from "zod";
import { IsoDateTimeString } from "../validate";

export const DynamicThemeFormSchema = z.object({
    published: IsoDateTimeString.nullable(),
});

export type DynamicThemeFormSchema = z.infer<typeof DynamicThemeFormSchema>;

export const StaticThemeFormContentSchema = z.object({
    tenant: ThemeContentTenantSchema,
    catalogItemIds: z
        .array(z.string({ error: "Add at least one article" }))
        .min(1, "Add at least one article"),
});

export type StaticThemeFormContent = z.infer<typeof StaticThemeFormContentSchema>;

export const StaticThemeFormSchema = z.object({
    name: z
        .string({ error: "Add name" })
        .min(3, "Add name")
        .max(dynamicThemeNameMaxLength, "Limit for name is 255 characters"),
    content: z
        .array(StaticThemeFormContentSchema)
        .min(1, "Add at least one article")
        .refine(
            (content) => content.some((c) => c.tenant === "default"),
            "Default content is required",
        ),
    preferences: z.array(ThemePreference),
    location: z.array(ThemeLocation),
    published: IsoDateTimeString.nullable(),
});

export type StaticThemeFormSchema = z.infer<typeof StaticThemeFormSchema>;

export const TenantPointOfViewSchema = TenantSchema.or(z.literal("global"));
export type TenantPointOfView = z.infer<typeof TenantPointOfViewSchema>;

export type ThemeQueryFilters = {
    nameSearchTerm: string | undefined;
    location: ThemeLocation | undefined;
    preferences: ThemePreference[] | undefined;
    published: VisibilityFilter | undefined;
    tenantPointOfView: TenantPointOfView | undefined;
};
